import React, { useEffect, useState } from 'react'
import PageHead from '../components/PageHead'
import Input from '../ui/forms/Input'
import Button from '../ui/comp/Button'
import { FiEdit, FiPlus } from 'react-icons/fi'
import Container from '../ui/comp/Container'
import Table from '../ui/Table/Table'
import Thead from '../ui/Table/Thead'
import Td from '../ui/Table/Td'
import Avatar from '../ui/comp/Avatar'
import Tbody from '../ui/Table/Tbody'
import FormatCurrency from '../utils/FormatCurrency'
import { CgTrash } from 'react-icons/cg'
import { GoEye } from 'react-icons/go'
import Status from '../ui/Table/Status'
import { Link } from 'react-router-dom'
import { useProducts } from '../hooks/useProducts'
import Loading from '../components/Loading'
import NoContent from '../components/NoContent'
import { CiExport } from 'react-icons/ci'
import { displayImage, exportButton } from '../utils/config'
import Switch from 'react-switch'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Axios } from '../utils/Axios'
import ReactPaginate from 'react-paginate'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'



function Product() {


    const [products, setProduct] = useState([]);
    const [searchText, setSearchText] = useState("")
    const queryClient = useQueryClient()

    const [page, setPage] = useState(1);
    const limit = 50
    const [totalPages, setTotalPages] = useState(0)


    const { data, isLoading, refetch } = useProducts(page, limit, searchText);

    useEffect(() => {
        setProduct(data?.products || [])
        setTotalPages(data?.totalPages)
    }, [data])


    // chenging customise and publish

    const { mutate } = useMutation({
        mutationFn: async (payload) => {
            return Axios.post(`/product/change?id=${payload?.id}&target=${payload?.target}`)
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['products'])
        }
    })

    const handleChangeSwitch = (id, target) => {
        mutate({ id, target })
    }

    // Delete Product

    const { mutate: deleteProduct } = useMutation({
        mutationFn: async (id) => {
            return Axios.delete(`/product/delete`, { params: { product_id: id } })
        },
        onSuccess: () => {
            queryClient.invalidateQueries('products')
        }
    })

    const handleDelete = (id) => {
        if (window.confirm("Are you sure")) {
            deleteProduct(id)
        }
    }


    // Show Loading Content

    if (isLoading) {
        return (
            <div><Loading /> </div>
        )
    }

    return (
        <div className='w-full relative'>

            <PageHead title="Products" />

            {/* Filter palce */}
            <div className="flex items-center justify-between w-full mt-8">
                <div className='max-w-48 w-full'>
                    <Button
                        onClick={() => exportButton("products")}
                        color={'primary'}
                        icon={<CiExport size={18} />}
                    >
                        Export
                    </Button>
                </div>

                <div className='flex items-center gap-3'>
                    <Input placeholder="Product name" onChange={(e) => {
                        setSearchText(e.target.value)
                        setTimeout(() => {
                            refetch()
                        }, 500);
                    }} />
                    <Button icon={<FiPlus />} ><Link to="/products/new">Add Product</Link></Button>
                </div>
            </div>


            {/* Products */}
            {
                products?.length ? (
                    <div className="w-full mt-7">
                        <Container title={"Product List"}>
                            <Table>
                                <Thead>
                                    <tr>
                                        <Td>Product Name</Td>
                                        <Td>Category</Td>
                                        <Td>Price</Td>
                                        <Td>Stock</Td>
                                        <Td>Status</Td>
                                        <Td>Discount</Td>
                                        <Td>Customized</Td>
                                        <Td>Available</Td>
                                        <Td>View</Td>
                                        <Td>Actions</Td>
                                    </tr>
                                </Thead>

                                <Tbody>
                                    {products?.map((product, i) => (
                                        <tr key={i}>
                                            <Td>
                                                <div className="flex items-center gap-2">
                                                    <Avatar src={displayImage(product?.image)} rounded={true} />
                                                    {product?.name}
                                                </div>
                                            </Td>

                                            <Td>{product?.category?.name}</Td>
                                            <Td><FormatCurrency amount={product?.base_price} /></Td>
                                            <Td>{product?.stock}</Td>
                                            <Td><Status status={product?.instock ? 'In Stock' : 'Pending'} /></Td>
                                            <Td>{product?.discount}</Td>
                                            <Td>
                                                <Switch
                                                    checked={product?.customised}
                                                    onChange={() => handleChangeSwitch(product?.id, 'customise')}
                                                    checkedIcon={false}
                                                    uncheckedIcon={false}
                                                    onColor='#180787'
                                                    height={20}
                                                    handleDiameter={15}
                                                    width={38}
                                                />
                                            </Td>
                                            <Td>
                                                <Switch
                                                    checked={product?.in_stock}
                                                    onChange={() => handleChangeSwitch(product?.id, 'in_stock')}
                                                    checkedIcon={false}
                                                    uncheckedIcon={false}
                                                    onColor='#180787'
                                                    height={18}
                                                    handleDiameter={14}
                                                    width={38}
                                                />
                                            </Td>

                                            <Td>
                                                <Link to={`/products/${product?.id}/view`} className='text-gray-500'>
                                                    <GoEye size={18} />
                                                </Link>
                                            </Td>

                                            <Td>
                                                <div className="flex items-center gap-3 text-gray-500">
                                                    <Link className='text-primary' to={`/products/edit/${product?.id}`} title='Edit'><FiEdit size={17} /></Link>
                                                    <button onClick={() => handleDelete(product?.id)} title='Delete' className='text-red-400'><CgTrash size={18} /></button>
                                                </div>
                                            </Td>
                                        </tr>
                                    ))}
                                </Tbody>
                            </Table>

                            {/* Pagination */}
                            <div className="p-2 flex justify-end">
                                <ReactPaginate
                                    nextLabel={<FaChevronRight />}
                                    previousLabel={<FaChevronLeft />}
                                    previousClassName='mr-2 text-primary/80'
                                    nextClassName='ml-2 text-primary/80'
                                    containerClassName='flex text-sm items-center gap-2'
                                    activeClassName='bg-primary text-white'
                                    pageClassName='size-8 rounded-lg bg-gray-100 flex items-center justify-center'
                                    pageCount={totalPages}
                                    onPageChange={({ selected }) => {
                                        setPage(selected + 1)
                                    }}
                                />
                            </div>
                        </Container>
                    </div>
                ) : <NoContent />
            }
        </div >
    )


}

export default Product